import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdHeartHalf } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import TabbedView from "../components/TabbedView";
import {
  STR_DESCRIPTION,
  STR_DISTRICT,
  STR_FIND_MATCH,
  STR_INVALID_DESCRIPTION,
  STR_INVALID_DISTRICT,
  STR_INVALID_REGION,
  STR_LATEST_ARTICLES,
  STR_MENU_ARTICLES,
  STR_MENU_STORIES,
  STR_MENU_UTILITIES,
  STR_MORE_ARTICLES,
  STR_OPTIONAL,
  STR_PLEASE_UPDATE_YOUR_PERSONAL_INFO,
  STR_PLEASE_WAIT,
  STR_REGION,
  STR_SUBMIT,
  STR_SUCCESS,
  STR_TITLE_FIND_MATCH,
  STR_YOUR_PHOTO
} from "../Strings";
import PersonalInfoUpdateWidget from '../ones/PersonalInfoUpdateWidget';
import { MdImage } from "react-icons/md";
import LoginView from '../views/LoginView';

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [region, setRegion] = useState("");
  const [district, setDistrict] = useState("");
  const [cover, setCover] = useState(null);

  const [regions, setRegions] = useState(null);
  const [districts, setDistricts] = useState(null);

  async function init() {
    //run initializations here
    setReady(false);
    appContext.getRegions().then((_regions) => {
      setRegions(_regions);
      setReady(true);
    })
    
  }

  async function submit() {
    //get cover
    const _cover = document.getElementById("_cover").files[0];

    if (!loading) {
      if (description.trim().length > 0) {
        if (region.trim().length > 0) {
          if (district.trim().length > 0) {
            setLoading(true);
            await callApi(
              "post-match-feed", 
              { 
                description, 
                region, 
                district,
                cover: (_cover) ? _cover : "",
              }
            ).then(response => {
              if (response.status === 1) {
                appContext.tellMessage(STR_SUCCESS[appContext.language]);
                appContext.getDatingFeed();
                appContext.navBack();
              } else {
                appContext.tellError(response.msg);
              }
            })
            setLoading(false);
          } else {
            appContext.tellError(STR_INVALID_DISTRICT[appContext.language])
          }
        } else {
          appContext.tellError(STR_INVALID_REGION[appContext.language])
        }
      } else {
        appContext.tellError(STR_INVALID_DESCRIPTION[appContext.language])
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language])
    }
  }

  async function handleRegionChange() {
    if (region && regions) {
      //reset district selection
      setDistricts(null);
      setDistrict("");

      //set regionId
      let _regionId = null;

      for (const _region of regions) {
        if (_region.name === region) {
          _regionId = _region.id;
          break;
        }
      }

      if (_regionId) {
        //get districts
        setLoading(true);
        await appContext.getDistricts({ regionId: _regionId }).then(_districts => {
          setDistricts(_districts);
        })
        setLoading(false);
      }
    }
  }

  function getCover(e) {
		// Ensure the event has a file input with a file selected
		if (e.target && e.target.files && e.target.files[0]) {
			const file = e.target.files[0];

			// Use FileReader to read the file and generate a URL
			const reader = new FileReader();

			// On load, set the result (URL) to an image src or handle it as needed
			reader.onload = function (event) {
				const fileURL = event.target.result;
				setCover(fileURL); // Replace with your image handling logic
			};

			// Read the file as a Data URL
			reader.readAsDataURL(file);
		} else {
			//..
		}
	}

  useEffect(() => {
    init();
  }, [])


  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])


  useEffect(() => {
    handleRegionChange();
  }, [region])

  if(appContext.auth && appContext.currentUserData) {
    return (
      <div className="container">
        <h6 className="mSectionTitle">{STR_TITLE_FIND_MATCH[appContext.language]}</h6>
  
        {
          (
            appContext.currentUserData.username &&
            appContext.currentUserData.username.trim().length > 0 &&
            appContext.currentUserData.gender
          ) ?
            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="form-label">{STR_DESCRIPTION[appContext.language]}</label>
                <textarea
                  className="form-control"
                  onChange={(e) => {
                    setDescription(e.target.value)
                  }}
                  rows={4}
                  maxLength={300}
                  value={description}
                ></textarea>
                <div className="form-text">
                  {description.length}/300
                </div>
              </div>
  
              <div className="col-6 mb-3">
                <label className="form-label">{STR_REGION[appContext.language]}</label>
                <select
                  className="form-control"
                  onChange={(e) => {
                    setRegion(e.target.value)
                  }}
                  value={region}
                >
                  <option value=""></option>
                  {
                    (regions && regions.length > 0) ?
                      regions.map((item, i) => {
                        return (
                          <option key={i} value={item.name}>{item.name}</option>
                        )
                      })
                      : ""
                  }
                </select>
              </div>
  
              <div className="col-6 mb-3">
                <label className="form-label">{STR_DISTRICT[appContext.language]}</label>
                <select
                  className="form-control"
                  onChange={(e) => {
                    setDistrict(e.target.value)
                  }}
                  value={district}
                >
                  <option value=""></option>
                  {
                    (districts && districts.length > 0) ?
                      districts.map((item, i) => {
                        return (
                          <option key={i} value={item.name}>{item.name}</option>
                        )
                      })
                      : ""
                  }
                </select>
              </div>
  
              <div className="col-md-12 mb-3">
                <label className="form-label">{STR_YOUR_PHOTO[appContext.language]}</label>
                <div className="form-text">
                  {STR_OPTIONAL[appContext.language]}
                </div>
                {
                  (cover) ?
                    <img
                      width="100%"
                      height="auto"
                      src={cover}
                      onClick={() => {
                        document.getElementById('_cover').click();
                      }}
                    />
                    :
                    <MdImage
                      style={{
                        width: "100%",
                        height: "auto",
                        color: "var(--mutedColor)"
                      }}
                      onClick={() => {
                        document.getElementById('_cover').click();
                      }}
                    />
                }
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  id="_cover"
                  onChange={(e) => getCover(e)}
                />
                
              </div>
  
              <div className="col-md-12 text-end">
                <button
                  className="btn btn-rounded btn-padded btn-secondary mt-4 mb-4"
                  onClick={submit}
                >
                  {STR_SUBMIT[appContext.language]}
                </button>
              </div>
            </div>
            :
            <PersonalInfoUpdateWidget title={STR_PLEASE_UPDATE_YOUR_PERSONAL_INFO[appContext.language]} />
        }
      </div>
    )
  } else {
    return <LoginView/>
  }


}